import React from "react";
import Cta from "./Cta";
const Notification = () => {
  return (
    <>
      <div class="col-lg-6 col-xl-6 col-4-xxxl">
        <div class="card dashboard-card-six pd-b-20">
          <div class="card-body">
            <div class="heading-layout1 mg-b-17">
              <div class="item-title">
                <h3>Notice Board</h3>
              </div>
              <Cta />
            </div>
            <div class="notice-box-wrap">
              <div class="notice-list">
                <div class="post-date bg-skyblue">16 June, 2019</div>
                <h6 class="notice-title">
                  <a href="#">
                    Great School manag mene esom text of the printing.
                  </a>
                </h6>
                <div class="entry-meta">
                  Jennyfar Lopez / <span>5 min ago</span>
                </div>
              </div>
              <div class="notice-list">
                <div class="post-date bg-yellow">16 June, 2019</div>
                <h6 class="notice-title">
                  <a href="#">Great School manag printing.</a>
                </h6>
                <div class="entry-meta">
                  Jennyfar Lopez / <span>5 min ago</span>
                </div>
              </div>
              <div class="notice-list">
                <div class="post-date bg-pink">16 June, 2019</div>
                <h6 class="notice-title">
                  <a href="#">Great School manag meneesom.</a>
                </h6>
                <div class="entry-meta">
                  Jennyfar Lopez / <span>5 min ago</span>
                </div>
              </div>
              <div class="notice-list">
                <div class="post-date bg-skyblue">16 June, 2019</div>
                <h6 class="notice-title">
                  <a href="#">
                    Great School manag mene esom text of the printing.
                  </a>
                </h6>
                <div class="entry-meta">
                  Jennyfar Lopez / <span>5 min ago</span>
                </div>
              </div>
              <div class="notice-list">
                <div class="post-date bg-yellow">16 June, 2019</div>
                <h6 class="notice-title">
                  <a href="#">Great School manag printing.</a>
                </h6>
                <div class="entry-meta">
                  Jennyfar Lopez / <span>5 min ago</span>
                </div>
              </div>
              <div class="notice-list">
                <div class="post-date bg-pink">16 June, 2019</div>
                <h6 class="notice-title">
                  <a href="#">Great School manag meneesom.</a>
                </h6>
                <div class="entry-meta">
                  Jennyfar Lopez / <span>5 min ago</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Notification;
